import { jsx as _jsx } from "react/jsx-runtime";
import { DployTextField } from "@ploy-ui/form-fields";
import { useField } from "formik";
import Autocomplete from "@material-ui/lab/Autocomplete";
export function FormikAutocompleteField(props) {
    const { multiple, name, helperText, label, variant, margin, ...rest } = props;
    const [field, meta, helpers] = useField(name);
    const error = meta.error;
    const showError = Boolean(error) && meta.touched;
    return (_jsx(Autocomplete, { ...rest, ...field, value: field.value ?? (multiple ? [] : null), onChange: (_, val) => helpers.setValue(val), multiple: multiple, renderInput: params => (_jsx(DployTextField, { name: name, label: label, error: showError, helperText: showError ? error : helperText, variant: variant, margin: margin, ...params })) }));
}
//# sourceMappingURL=FormikAutocompleteField.js.map